module.exports = __webpack_public_path__ + "img/cup.42aadb0f.png";